<template>
	<div>
		<div v-for="(v, index) in valuesList" v-bind:key="index">
			<b-row>
				<b-col cols="11">
					<b-form-input
						type="text"
						:value="value"
						:state="state"
						:size="fieldInfo.size"
						v-model="v.value"
						:name="fieldInfo.name"
						@change="fieldChange(index, v.value)"
						:readonly="!active"
						:key="active"
					></b-form-input>
				</b-col>
				<b-col cols="1">
					<k-eraser-button :key="active" :disabled="!active" @click="deleteOption(index)" />
				</b-col>
			</b-row>
		</div>

		<k-icon-button :key="active" :disabled="!active" @click="addNewOption" icon="plus-circle" />{{
			$t("components.kListOptions.addAlternative")
		}}

		<b-form-invalid-feedback :id="`${fieldInfo.name}-feedback`">
			{{ errors[fieldInfo.name] }}
		</b-form-invalid-feedback>
	</div>
</template>

<script>
import KIconButton from "../Buttons/KIconButton.vue";
import KEraserButton from "../Buttons/KEraserButton.vue";
export default {
	components: { KIconButton, KEraserButton },
	props: {
		fieldInfo: {
			type: Object
		},
		value: {
			type: Array,
			defatult: []
		},
		state: {
			type: Boolean,
			default: null
		},
		errors: {
			type: Object
		},
		isActive: {
			type: [Boolean, Function],
			required: true
		}
	},
	computed: {
		valuesList: {
			get() {
				return this.value
					? this.value.map((val) => {
							return { value: val };
					  })
					: null;
			},
			set(newVal) {
				let response = [];
				newVal.forEach((option) => {
					response.push(option.value);
				});
				this.$emit("input", response);
				this.$emit("change", this.fieldInfo.name);
			}
		}
	},
	methods: {
		addNewOption: function () {
			this.value.push("");
		},
		deleteOption: function (index) {
			this.value.splice(index, 1);
		},
		fieldChange: function (index, newValue) {
			this.value[index] = newValue;
			this.$emit("input", this.value);
		},
		parentChanged: function (parentValue) {
			if (typeof this.isActive == "function") {
				this.active = this.isActive(parentValue);

				if (this.value) {
					this.value.push("");
					this.value.pop();
				}
			}
		}
	},
	beforeMount() {
		if (typeof this.isActive == "function") this.active = this.isActive(null);
		else this.active = this.isActive;
	}
};
</script>
